/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_G2_DInputs */

const en_mk_sec_pg_g2_d = /** @type {(inputs: Mk_Sec_Pg_G2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each agent has a rupiah cap per month. Once it is reached, tasks are held — not quietly run anyway.`)
};

const id_mk_sec_pg_g2_d = /** @type {(inputs: Mk_Sec_Pg_G2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiap agen punya batas rupiah per bulan. Setelah tercapai, tugas ditahan — bukan dijalankan diam-diam.`)
};

/**
* | output |
* | --- |
* | "Each agent has a rupiah cap per month. Once it is reached, tasks are held — not quietly run anyway." |
*
* @param {Mk_Sec_Pg_G2_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_g2_d = /** @type {((inputs?: Mk_Sec_Pg_G2_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_G2_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_g2_d(inputs)
	return en_mk_sec_pg_g2_d(inputs)
});